export default __webpack_public_path__ + "static/media/prproj.c824c2aa.svg";